import { uniq } from 'ramda'
import { handleActions } from 'redux-actions'
import * as c from './constants'
const init = {
  list: []
}

export default handleActions({
  [c.GET_NOTIFICATIONS]: (state, { error, payload = [] }) => {
    if (error) {
      return state
    }
    return {
      ...state,
      list: uniq([
        ...state.list,
        ...payload
      ])
    }
  },
  [c.ADD_NOTIFICATION]: (state, { payload = [] }) => {
    return {
      ...state,
      list: uniq([
        ...state.list,
        payload
      ])
    }
  }
}, init)
